import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './code-structure-tree.html';
import processNode from './process-node';

const COMPONENT_NAME = 'codeStructureTree';
const aceUIError = atex.aceui.error;

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,

    bindings: {
      config: '<'
    },

    controller: ($scope, $element, $timeout, ErrorMessagingService, StructureService) => {
      let ctrl = $scope.$ctrl;

      ctrl.refresh = () => {
        $element[0].dispatchEvent(new CustomEvent('refresh'));
      };

      ctrl.loadRoots = (roots = []) => {
        ctrl.structureRoots = undefined;
        ctrl.isLoading = true;

        Promise.allSettled (roots.map (alias => StructureService.getContentStructure({ alias })))
          .then ((results) => {
            $timeout(() => {
              ctrl.structureRoots = results.map((result, index) => {
                if (result.value) {
                  let rootNode = processNode(result.value);
                  rootNode.structure = (rootNode.structure || []).map (processNode);
                  return rootNode;
                } else {
                  if (result.reason.type === atex.aceui.error.types.PERMISSION_DENIED) {
                    return {
                      name: roots[index],
                      disabled: true,
                      structure: []
                    };
                  }

                  return {
                    name: result.reason.cause,
                    structure: [],
                    error: result.reason
                  };
                }
              });
            });
          })
          .catch ((error) => {
            ErrorMessagingService.sendError(aceUIError.Error ({
              type: atex.aceui.error.types.RUNTIME,
              severity: atex.aceui.error.severities.MINOR,
              origin: COMPONENT_NAME,
              cause: 'Error while loading content structure',
              rootCause: error
            }));
          })
          .then (() => { 
            $timeout (() => ctrl.isLoading = false);
          });
      };

      ctrl.$onChanges = ({ config }) => {
        if (config) {
          if (config.currentValue) {
            ctrl.loadRoots (config.currentValue.structureRoots);
          } else {
            ctrl.loadRoots ();
          }
        }
      };
    }
  });

export default COMPONENT_NAME;
